import * as Sentry from '@sentry/svelte';
import type { HandleClientError } from '@sveltejs/kit';
import { dev } from '$app/environment';

Sentry.init({
	dsn: 'https://e9a3e1efe294495596e3f94117bb0e87@o4504737804255232.ingest.sentry.io/4504737832370176',
	tracesSampleRate: 1.0,
	environment: dev ? 'development' : 'production',
	integrations: [
		Sentry.replayIntegration(),
	],
	replaysSessionSampleRate: dev ? 1.0 : 0.1,
	replaysOnErrorSampleRate: 1.0, 
});

Sentry.setTag('svelteKit', 'server');

export const handleError: HandleClientError = ({ error, event }) => {
	Sentry.captureException(error, { contexts: { sveltekit: { event } } });

	return {
		message: (error as App.Error).message
	};
};
